module.exports = "../images/hiking.png?v=89d5342";